import { formValueSelector } from 'redux-form'
import { PRODUCT_SHIP_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import { PROPOSAL_LISTING_FORM_KEY } from '../../constants/proposalTypes'
import { WARRANTY_HANDLER_FIELD, WARRANTY_SCOPE_FIELD, WARRANTY_PERIOD_FIELD } from '../../components/Proposal/Shared'
import { getFormSyncErrors } from '../../components/Common/forms'

const select = (state, params) => {
  const formKey = Object.keys(state.form)[0]
  const selector = formValueSelector(formKey)
  return selector(state, params)
}

export const SHIP_TYPE_ID_FIELD_NAME = 'product.shipType.id'

/**
 * 一般 getXXX 是 reduxFormSelector，
 * 傳進去的參數為 state
 *
 * 若要直接從 allValues 取資料，
 * 則把 allValues 包裹成 state 的形式再丟入 getXXX
 * */

/**
 * shipTypeId200 + model150 在 UI 狀態轉換成 shipTypeId200150
 * shipTypeId200150 在 API params 時轉換成 shipTypeId200
 */
export const getShipTypeId = (state, isUIState = false) => {
  const model = select(state, 'product.shipType.model')
  let shipTypeId = getFormShipTypeId(state)
  if (!isUIState && shipTypeId === PRODUCT_SHIP_TYPE.E_VOUCHER) {
    shipTypeId = PRODUCT_SHIP_TYPE.ESD
  } else if (shipTypeId === PRODUCT_SHIP_TYPE.ESD && model === 150) {
    shipTypeId = PRODUCT_SHIP_TYPE.E_VOUCHER
  }
  return shipTypeId
}
export const getFormShipTypeId = state => {
  return +select(state, SHIP_TYPE_ID_FIELD_NAME) || PRODUCT_SHIP_TYPE.HOME
}
export const getShipTypeIdFromAllValues = (allValues, isUIState) => {
  const shipTypeId = getShipTypeId(wrapAllValues(allValues), isUIState)
  return shipTypeId
}
export const getProposalType = state => select(state, 'type') || ''
export const getPropposalTypeFromAllValues = allValues => getProposalType(wrapAllValues(allValues))
export const getIsExpiringItem = state => select(state, 'setting.showExpiringAddon') || false
export const getIsExpiringItemFromAllValues = allValues => getIsExpiringItem(wrapAllValues(allValues))

export const getPrice = state => select(state, 'listing.price')
export const getSubStationId = state => select(state, 'subStationId')

export const getProductName = state => select(state, 'product.name')
export const getProductNameFromAllValues = allValues => getProductName(wrapAllValues(allValues))
export const getCatItemId = state => select(state, 'product.catItemId')
export const getAttrClusterId = state => select(state, 'product.struDataAttrClusterId')
export const getPeriod = state => select(state, WARRANTY_PERIOD_FIELD)
export const getScope = state => select(state, WARRANTY_SCOPE_FIELD)
export const getHandler = state => select(state, WARRANTY_HANDLER_FIELD)

export const getSetting = state => select(state, 'setting')
export const getStruDataAttrCluster = state => select(state, 'setting.struDataAttrCluster') || {}
export const getReadOnly = state => select(state, 'setting.readOnly')
export const getUser = state => select(state, 'setting.user') || {}
export const getShowExpiringAddon = state => select(state, 'setting.showExpiringAddon')

/** fieldName 不固定的時候可以用 */
export const getProposalListingFormValue = state => fieldName => select(state, fieldName) || {}

/** 把 allValues 包成 state 型態 */
export const wrapAllValues = allValues => ({
  form: {
    [PROPOSAL_LISTING_FORM_KEY]: {
      values: allValues
    }
  }
})

// cache using substation and attrCluster
export const selectFormError = state => {
  const formKey = Object.keys(state.form)[0] || PROPOSAL_LISTING_FORM_KEY
  const errorSelector = getFormSyncErrors(formKey)
  return errorSelector(state)
}
